import {
  ApproveRejectBudgetDialog,
  DataTable,
  FormSectionHeader,
  Heading,
  Loader,
  MonthlyDistribution,
} from "@/components";
import useReviewBudget from "./useReviewBudget";
import { Button, Card, CardContent } from "@/components/ui";
import moment from "moment";
import { formatAmount, formatTwoDigits } from "@/lib/utils";

const ReviewBudget = () => {
  const {
    breadcrumbData,
    onBackClick,
    columns,
    budgetInfo,
    isBudgetDataLoading,
    lineItems,
    isLineItemDataLoading,
    commentsData,
    isCommentsLoading,
    openDistributionDialog,
    setOpenDistributionDialog,
    rowSelected,
    onApproveClick,
    onRejectClick,
    onApproveConfirm,
    onRejectConfirm,
    openApproveRejectDialog,
    isApproved,
    isApprovePending,
    isRejectPending,
    onClose,
    hideApproveRejectBtn,
    isView,
  } = useReviewBudget();

  return (
    <div className="p-4 md:p-6">
      {/* Header & Search */}
      <div className="flex flex-col lg:flex-row gap-2 lg:items-center lg:justify-between mb-6">
        <div className="flex flex-row items-center justify-between">
          <Heading
            title={budgetInfo?.data?.budgetName || ""}
            breadcrumbData={breadcrumbData}
            showBack
            onBackClick={onBackClick}
          />
        </div>
      </div>

      {isBudgetDataLoading ||
      isLineItemDataLoading ||
      isCommentsLoading ? (
        <Loader />
      ) : (
        <>
          <Card className="rounded-xl shadow border bg-primary text-white mb-3">
            <CardContent className="grid grid-cols-2 md:grid-cols-3 gap-4 text-sm">
              <div>
                Budget ID :{" "}
                <span className="font-semibold">
                  {budgetInfo?.data?.budgetId}
                </span>
              </div>
              <div>
                Total Budget :{" "}
                <span className="font-semibold">
                  {formatAmount(
                    budgetInfo?.data?.totalExpenseByCategory?.Expense
                  )}
                </span>
              </div>
              <div>
                Min Approvals :{" "}
                <span className="font-semibold">
                  {formatTwoDigits(
                    budgetInfo?.data?.minApprovalRequired || "0"
                  )}
                </span>
              </div>
              <div>
                Year :{" "}
                <span className="font-semibold">{budgetInfo?.data?.year}</span>
              </div>
              <div>
                Submitted On :{" "}
                <span className="font-semibold">
                  {moment(budgetInfo?.data?.submittedOn).format("MM/DD/YYYY")}
                </span>
              </div>
              <div>
                Total Approvals :{" "}
                <span className="font-semibold">
                  {formatTwoDigits(budgetInfo?.data?.totalApprovals || "0")}
                </span>
              </div>
            </CardContent>
          </Card>

          <DataTable
            columns={columns}
            data={(lineItems?.data || []).sort(
              (a: any, b: any) =>
                new Date(b.updatedAt).getTime() -
                new Date(a.updatedAt).getTime()
            )}
          />

          {isView ? (
            <></>
          ) : hideApproveRejectBtn() ? (
            budgetInfo?.data?.status?.toLowerCase() == "pending_approval" && (
              <div className="flex justify-end gap-4 my-6">
                <Button
                  variant="destructive"
                  type="button"
                  onClick={onRejectClick}
                >
                  Reject
                </Button>
                <Button
                  className="bg-green-700 hover:bg-green-700"
                  type="button"
                  onClick={onApproveClick}
                >
                  Approve
                </Button>
              </div>
            )
          ) : (
            <></>
          )}

          <div className="bg-white mt-[20px] rounded-lg px-[30px] py-[25px]">
            <FormSectionHeader className="text-[20px]">
              Comments
            </FormSectionHeader>
            <div className="max-h-[150px] overflow-y-auto grid grid-cols-1 gap-[20px]">
              {commentsData?.data
                ?.sort(
                  (a: any, b: any) =>
                    new Date(b.createdAt).getTime() -
                    new Date(a.createdAt).getTime()
                )
                ?.map((data: any) => {
                  return (
                    <div
                      key={data.commentId}
                      className="text-sm flex flex-col gap-1"
                    >
                      <div className="text-primary font-[500]">
                        {data?.createdByName}: (
                        {moment(data?.createdAt)
                          .local()
                          .format("MM/DD/YYYY hh:mm A")}
                        )
                      </div>
                      <div className="font-[400]">{data?.comment}</div>
                    </div>
                  );
                })}
            </div>
          </div>
        </>
      )}
      {openDistributionDialog && (
        <MonthlyDistribution
          openDistributionDialog={openDistributionDialog}
          setOpenDistributionDialog={setOpenDistributionDialog}
          annualBudget={rowSelected?.budgetYearlyAmt}
          rowSelected={rowSelected}
          isView
        />
      )}
      {openApproveRejectDialog && (
        <ApproveRejectBudgetDialog
          open={openApproveRejectDialog}
          onClose={onClose}
          onConfirm={isApproved ? onApproveConfirm : onRejectConfirm}
          isLoading={isApprovePending || isRejectPending}
          isApproved={isApproved}
        />
      )}
    </div>
  );
};

export default ReviewBudget;
